/**
 * Allows for the generation of nested columns as a subset defined
 * within a `type: nested` column.
 * @param cachedColumn
 * @param rowData
 * @param createElement
 * @param grid
 * @param columnTypeRenderMap
 * @returns {array}
 */
export default function nestedColumn({
    cachedColumn,
    rowData,
    createElement,
    grid,
    columnTypeRenderMap,
}) {
    const params = {
        rowData,
        createElement,
        grid,
        columnTypeRenderMap,
    };
    const children = cachedColumn.columns
    // checked if the cachedColumn should render
        .filter((column) => {
            // TODO consider modifying `shouldRender` instead
            // and check for side-effects
            if (column.predicate !== null) {
                if (column.predicate === false) {
                    return column.predicate;
                }
            }
            return column.shouldRender({rowData});
        })
        .reduce((result, col, index, list) => [
            ...result,
            // skip the inline spacer for the last item
            ['div', {class: index !== list.length - 1 ? `inline-s` : ''},
                [
                    createElement(...columnTypeRenderMap[col.type]({
                        ...params,
                        cachedColumn: col,
                    })),
                ],
            ],
        ], []).map(args => createElement(...args));
    return [
        'div',
        {
            class: 'grid-fitted display-inline-flex',
        },
        children,
    ];
}
